// export const API_URL = 'https://learnmed.ru/admin';
export const API_URL_TELEGRAM_BOT = 'https://uchi-med.ru';
// export const BASE_URL = 'https://learnmed.ru/resource';

export const API_URL = 'https://u4imed.ru/admin';
export const BASE_URL = 'https://u4imed.ru/resource';
export const API_URL_VIDEO_LECTION = 'https://uchianat.ru/admin';

export const IS_DEBUG = true;
